import { useSolveModeTranslation } from 'hooks/use-solve-mode';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = Omit<ComponentProps<'h5'>, 'children'> & { solveMode: string | 'Unknown solve'; isPlural: boolean };

export function SectionTitle({ solveMode, isPlural = false, ...props }: Props) {
  const translateSolveMode = useSolveModeTranslation();

  return (
    <h5 {...props}>
      <FormattedMessage
        id="smartQuote.workspace.main.solveModeResults.tableTitle"
        values={{ solveMode: translateSolveMode(solveMode), isPlural: isPlural ? 's' : '' }}
      />
    </h5>
  );
}
